jQuery(document).ready(function ($) {
  // Function to update the cart count and View Cart button text
  function updateCartDisplay(count) {
    var numericCount = parseInt(count, 10) || 0;
    $(".cart-count").text(numericCount);
    $(".mobile-cart-count").text(numericCount);
  }

  // Event listener for cart updates via WooCommerce events
  $(document.body).on(
    "added_to_cart removed_from_cart",
    function (event, fragments) {
      if (fragments && fragments[".woofc-count"]) {
        var cartCount = $(fragments[".woofc-count"])
          .find("#woofc-count-number")
          .text();
        updateCartDisplay(cartCount);
      }
    }
  );

  var initialCartCount = parseInt($(".cart-count").text(), 10) || 0;
  updateCartDisplay(initialCartCount);

  // Toggle profile dropdown
  function toggleProfileDropdown() {
    $(".profile-dropdown").slideToggle();
  }

  // Toggle cart flyout
  function toggleCartFlyout() {
    $("body").toggleClass("woofc-show");
  }

  // Profile icon click event
  $(".profile-icon").click(function (event) {
    toggleProfileDropdown();
    if ($("body").hasClass("woofc-show")) {
      toggleCartFlyout(); // Close cart if open
    }
    event.stopPropagation();
  });

  // Cart button click events
  $(".fly-cart-btn, .mobile-fly-cart-btn").click(function (event) {
    toggleCartFlyout();
    if ($(".profile-dropdown").is(":visible")) {
      toggleProfileDropdown(); // Close profile dropdown if open
    }
    event.stopPropagation();
  });

  // Click anywhere to close both the cart and the profile dropdown
  $(document).click(function (event) {
    if (
      !$(event.target).closest(".profile-dropdown, .profile-icon").length &&
      $(".profile-dropdown").is(":visible")
    ) {
      toggleProfileDropdown();
    }
    if (
      !$(event.target).closest(".woofc-inner").length &&
      $("body").hasClass("woofc-show")
    ) {
      toggleCartFlyout();
    }
  });

  // Prevent closing on click inside
  $(".profile-dropdown, .woofc-inner").click(function (event) {
    event.stopPropagation();
  });
});
